'use client';

import { useInView } from '@/lib/useInView';

interface CaseStudyHeaderProps {
  header: string;
  subheader: string;
  className?: string;
}

export default function CaseStudyHeader({ 
  header, 
  subheader,
  className = "" 
}: CaseStudyHeaderProps) {
  const { ref } = useInView<HTMLDivElement>();

  return (
    <div ref={ref} className={`animate-in-view ${className}`}>
      <h2 className="eyebrow-lg pb-2">{subheader}</h2>
      <p className="body-xl max-w-4xl">{header}</p>
      <div className="vs-article"></div>
    </div>
  );
}
